<crm-deal-event-reschedule-form
  *ngIf="!saving"
  [canDelete]="true"
  [dealEvent]="dealEvent"
  (save)="save($event)"></crm-deal-event-reschedule-form>

<crm-spinner *ngIf="saving"></crm-spinner>
